import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { api, errMsg } from "@/lib/api";

const MODE_TEXT = {
  live: ["LIVE", "Paid orders are sent to Printify and printed for real.", "!border-[#2E6930] !bg-[#E8F3E8] !text-[#2E6930]"],
  draft: ["DRAFT ONLY", "Stripe is in test mode, so orders are created in Printify only to check costs, then canceled automatically. Nothing is printed.", "!border-[#D97706] !bg-[#FFF7E6] !text-[#92400E]"],
  mock: ["MOCK", "No Printify token is set, so printing is simulated.", ""],
};

export const AdminPrintify = () => {
  const [s, setS] = useState(null);
  const [approval, setApproval] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => {
    api.get("/admin/printify/status").then(({ data }) => setS(data));
    api.get("/admin/integrations").then(({ data }) => setApproval(!!data.require_admin_approval));
  }, []);
  useEffect(() => { load(); }, [load]);
  const toggle = async (v) => {
    try { await api.put("/admin/approval", { required: !v }); setApproval(!v); toast.success(v ? "Paid orders will go to Printify automatically" : "You'll approve each order first"); } catch (e) { toast.error(errMsg(e)); }
  };
  const hooks = async () => {
    setBusy(true);
    try { await api.post("/admin/printify/webhooks"); toast.success("Shipping updates turned on"); load(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (!s) return null;
  const [label, text, cls] = MODE_TEXT[s.mode];
  return (
    <div className="paper-card space-y-4 p-6" data-testid="printify-card">
      <div className="flex flex-wrap items-center gap-3">
        <p className="font-serif text-2xl font-bold">Printify printing</p>
        <span className={`badge-mock ${cls}`} data-testid="printify-mode">{label}</span>
        {s.shop && <span className="text-base text-[#5C4A3E]">Shop: {s.shop}</span>}
      </div>
      <p className="text-lg">{text}</p>
      {s.error && <p className="text-[#991B1B]" data-testid="printify-error">{s.error}</p>}
      {!!s.products.length && (
        <ul className="space-y-1 text-base" data-testid="printify-products">
          {s.products.map((p) => <li key={p.kind}>{p.available && p.size_ok ? "✓" : "✗"} {p.title}{p.units_per_item > 1 ? ` × ${p.units_per_item} per pack` : ""}</li>)}
        </ul>
      )}
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <label className="flex items-center gap-3 text-lg">
          <Switch checked={approval === false} onCheckedChange={toggle} data-testid="auto-fulfill-switch" />
          Send paid orders to Printify automatically
        </label>
        {s.configured && (
          <button className="btn-outline" onClick={hooks} disabled={busy} data-testid="printify-webhooks-button">
            {s.webhooks.length ? `Shipping updates on (${s.webhooks.length})` : "Turn on shipping updates"}
          </button>
        )}
      </div>
    </div>
  );
};
